import React from 'react'
import noData from 'assets/images/noData.jpg'
import { useTranslation } from 'react-i18next'

function NoData(): JSX.Element {
  const { t } = useTranslation()
  return (
    <div className=" h-100 text-white flex items-center justify-center  py-40">
      <img src={noData} width={19} height={19} alt="no Data" />
      {t('NoData')}
    </div>
  )
}

export default NoData
